import React from "reactn";
import { BoxForm } from "../../../../../components/UI/form";
import { Select } from "semantic-ui-react";
import { Icon } from 'semantic-ui-react';


class SectionOne extends React.PureComponent {
  componentDidMount() {
  }

  handleChange = (e, v) => {
    this.props.onAutomationChange({ [e]: v });
  };

  handleMultiSelectChange = (e, { value }) => {
    this.props.onAutomationChange({ audience: value });
  };

  getAvailableTypes = (automationFor, communicationType) => {
    const types = [];
    
    if (['Programs', 'Online', 'Events', 'Parties', 'Memberships'].includes(automationFor)) {
      types.push({ value: 'enrollment-reminder', label: 'Reminder to finalize enrollment ' });
    }
    if (communicationType === 'email' && ['Programs', 'Online'].includes(automationFor)) {
      types.push({ value: 'auto-payment-reminder', label: 'Reminder for auto-payment date' });
    }


    //Note: develop check-up later. Intended for organizer to send check-up emails to customers when they miss a class
    /*
     // Types available for Programs, Online
     if (['Programs', 'Online'].includes(automationFor)) {
      types.push({ value: 'check-up', label: 'Check Up' });
    }
    */ 

    if (['Programs', 'Online', 'Events', 'Parties'].includes(automationFor)) {
      types.push(
        { value: 'enrollment-confirmation', label: 'Enrollment Confirmation' },
        { value: 'reminder', label: 'Reminder' },
        { value: 'onboarding', label: 'Onboarding' }
      );
    }

    if (['Programs', 'Online', 'Events', 'Parties', 'Giftcards'].includes(automationFor)) {
        types.push({ value: 'follow-up', label: 'Follow Up' });
      
    }

    if (automationFor === 'Memberships') {
      types.push({ value: 'milestone', label: 'Milestone' });
    }
    

    return types;
  };

  getAvailableAudienceOptions = (automationFor, automationType) => {
    const baseOptions = [
      { key: 'all', text: 'All', value: 'all' },
      { key: 'new customer', text: 'New customer', value: 'new-customer' },
      { key: 'regular customer', text: 'Regular customer', value: 'regular-customer' }, 
      { key: 'loyal customer', text: 'Loyal customer (1Y+)', value: 'loyal-customer' },
    ];
    
    if(automationType === 'auto-payment-reminder'){
      return [{key: 'recurring', text: 'Recurring', value: 'recurring'}]
    }

    if (['Programs'].includes(automationFor)) {
      return [
        ...baseOptions,
        { key: 'drop-in', text: 'Drop-in', value: 'drop-in' },
        { key: 'free-trial', text: 'Free-trial', value: 'free-trial' },
        { key: 'recurring', text: 'Recurring', value: 'recurring' },
        
      ];
    }

    if (['Online'].includes(automationFor)) {
      return [
        ...baseOptions,
        { key: 'recurring', text: 'Recurring', value: 'recurring' },
      ];
    }

    return baseOptions;
  };

  customForm = () => {
    const { automation } = this.props;    
    
    const audienceOptions = this.getAvailableAudienceOptions(automation.automationFor, automation.automationType);
    const availableTypes = this.getAvailableTypes(automation.automationFor, automation.communicationType);

    const inputFieldsStyle = {
      fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
      whiteSpace: 'normal',
      wordWrap: 'break-word'
    };

    return (
      <div className="formbody" style={{ 
        padding: '0',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(75, 75, 75, 0.6)',
        border: '1px solid rgb(190, 190, 190)',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        width: '100%',
        maxWidth: '800px', 
        margin: '0 auto'
      }}>
        {/* header */}
        <div style={{
          padding: '8px 8px',
          borderBottom: '1px solid #e6f0ff',
          backgroundColor: '#f8fbff', 
          textAlign: 'center'
        }}>
          <h2 style={{
            margin: 0,
            fontSize: window.innerWidth < 768 ? '1.4rem' : '1.75rem',
            color: '#1a56db',
            fontWeight: window.innerWidth < 768 ? '600' : '700',
            letterSpacing: '-0.025em'
          }}>
            Customize Automation
          </h2>
        </div>

        {/* body */}
        <div style={{ 
          padding: '20px',
          backgroundColor: 'white'
        }}>
          <form>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                   minWidth: window.innerWidth < 768 ? '100px' : '180px',
                   fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Communication Type<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Choose between email or text message for your automation"
                />
                <select
                  className="input-fields"
                  style={{ 
                    flex: 1,
                    padding: window.innerWidth < 768 ? '6px 8px' : '12px 16px',
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    height: window.innerWidth < 768 ? '35px' : '50px',
                    borderRadius: '8px',
                    border: '1px solid #e6f0ff',
                    backgroundColor: 'rgb(216, 216, 216)',
                    cursor: 'not-allowed', 
                    minWidth: 0,
                    maxWidth: '100%',
                    width: '100%'
                  }}
                  value={automation.communicationType || ""}
                  name="communicationType"
                  onChange={e => this.handleChange(e.target.name, e.target.value)}
                  disabled={true}
                >
                  <option value="">Select Type</option>
                  <option value="email" style={inputFieldsStyle}>Email</option>
                  <option value="text" style={inputFieldsStyle}>Text/SMS</option>
                </select>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '100px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Automation For<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                  }}
                  title="Choose which listing this automation will apply to"
                />
                <select
                  className="input-fields"
                  style={{ 
                    flex: 1,
                    padding: window.innerWidth < 768 ? '6px 8px' : '12px 16px',
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    height: window.innerWidth < 768 ? '35px' : '50px',
                    borderRadius: '8px',
                    border: '1px solid #e6f0ff',
                    backgroundColor: 'rgb(233, 233, 233)',
                    cursor: automation.communicationType ? 'pointer' : 'not-allowed', 
                    minWidth: 0,
                    maxWidth: '100%',
                    width: '100%'
                  }}
                  value={automation.automationFor || ""}
                  name="automationFor"
                  onChange={e => this.handleChange(e.target.name, e.target.value)}
                  disabled={!automation.communicationType}
                >
                  <option value="" style={inputFieldsStyle}>Select listing type</option>
                  <option value="Programs" style={inputFieldsStyle}>Programs</option>
                  <option value="Online" style={inputFieldsStyle}>Online Virtual</option>
                  <option value="Events" style={inputFieldsStyle}>Events</option>
                  <option value="Parties" style={inputFieldsStyle}>Parties</option>
                  <option value="Memberships" style={inputFieldsStyle}>Memberships</option>
                  <option value="Giftcards" style={inputFieldsStyle}>Giftcards</option>
                </select>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                marginBottom: '24px',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '100px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600'
                }}>
                  Automation Type<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.3rem',
                  }}
                  title="Choose what event will trigger this automation"
                />
                <select
                  className="input-fields"
                  style={{ 
                    flex: 1,
                    padding: window.innerWidth < 768 ? '6px 8px 6px 12px' : '12px 16px',
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    height: window.innerWidth < 768 ? '35px' : '50px',
                    borderRadius: '8px',
                    border: '1px solid #e6f0ff',
                    backgroundColor: 'rgb(233, 233, 233)',
                    cursor: automation.automationFor ? 'pointer' : 'not-allowed', 
                    minWidth: 0,
                    maxWidth: '100%',
                    width: '100%'
                  }}
                  value={automation.automationType || ""}
                  name="automationType"
                  onChange={e => this.handleChange(e.target.name, e.target.value)}
                  disabled={!automation.automationFor}
                >
                  <option value="">Select Trigger</option>
                  {availableTypes.map(type => (
                    <option key={type.value} value={type.value}
                    style={inputFieldsStyle}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'flex-start',
                gap: window.innerWidth < 768 ? '8px' : '24px',
                padding: window.innerWidth < 768 ? '12px' : '20px',
                backgroundColor: 'rgb(255, 255, 255)',
                borderRadius: '12px',
                border: '2px solid rgb(230, 230, 230)',
              }}>
                <label style={{ 
                  minWidth: window.innerWidth < 768 ? '100px' : '180px',
                  fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                  color: '#1f2937',
                  fontWeight: '600',
                  paddingTop: '12px'
                }}>
                  Filter Audience<span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                </label>
                <Icon 
                  name='info circle' 
                  style={{ 
                    color: 'rgb(0, 0, 0)',
                    marginRight: '-8px',
                    marginBottom: '10px',
                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1.3rem',
                    marginTop: window.innerWidth < 768 ? '10px' : '6px'
                  }}
                  title="Choose who will receive this automation"
                />
                <Select
                  multiple
                  placeholder="Select Audience"
                  options={audienceOptions}
                  value={automation.audience || []}
                  onChange={this.handleMultiSelectChange}
                  disabled={!automation.automationType}
                  style={{ 
                    flex: 1,
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    backgroundColor: 'rgb(233, 233, 233)',
                    minWidth: 0,
                      maxWidth: '100%',
                      width: '100%'
                  }}
                  className="input-fields"
                  menuStyle={{
                    fontSize: window.innerWidth < 768 ? '0.85rem' : '1.1rem',
                    maxWidth: '100%'
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };
    
  render() {
    return (
      <BoxForm
        handleChange={this.handleChange}
        name={""}
        customForm={this.customForm()}
      />
    );
  }
}

export default SectionOne;